// extracted by mini-css-extract-plugin
module.exports = {"jds-Signature":"signature_jds-Signature__mdZ1b","jds-Signature__image":"signature_jds-Signature__image__nozsE","jds-Signature--rounded":"signature_jds-Signature--rounded__86vIM"};